import { getFirebaseAppGallery } from 'features/common/api/firebase'
import { getFirestore, collection, query, getDocs } from 'firebase/firestore'
import { BlogPost } from '../types'

export const getBlogPosts = async (): Promise<Array<BlogPost>> => {
  const firebaseApp = getFirebaseAppGallery()
  const COLLECTION_NAME = 'blog_posts'
  const db = getFirestore(firebaseApp)
  const q = query(collection(db, COLLECTION_NAME))
  const querySnapshot = await getDocs(q)

  const features: BlogPost[] = []
  querySnapshot.forEach((doc) => {
    const { title, url, card_header_url, date, show } = doc.data()
    if (show) {
      features.push({
        title,
        img: card_header_url,
        url,
        created_at: date.seconds
      })
    }
  })
  return features.sort((a, b) => ((a?.created_at || 1) > (b?.created_at || 0) ? -1 : 1)).slice(0, 10)
}
